import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "8",
  fill: "none",
  viewBox: "0 0 17 8"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.094 6.75h10.312c.436 0 .654 0 .835-.046.744-.19 1.325-.934 1.473-1.886.036-.232.036-.51.036-1.068s0-.836-.036-1.068c-.148-.952-.73-1.697-1.473-1.886C14.06.75 13.842.75 13.406.75H3.094c-.436 0-.654 0-.835.046C1.515.986.934 1.73.786 2.682.75 2.914.75 3.192.75 3.75s0 .836.036 1.068c.148.952.73 1.696 1.473 1.886.181.046.4.046.835.046"
    }, null, -1)
  ]))]))
}
export default { render: render }